import { createMedia } from "@artsy/fresnel";
import React, { Component } from "react";
import {
  Button,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  Segment,
} from "semantic-ui-react";
import NextLevel from "../components/NextLevel";
import { useMediaQuery } from 'react-responsive'

const { MediaContextProvider, Media } = createMedia({
  // breakpoints values can be either strings or integers
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  },
});
export function SolutionEnterprise_kr() {
  const isMobile = useMediaQuery({query: '(max-width: 768px)'})

    return (
      <>
        <Segment
          style={{
            border: 0,
            padding: "0em 0em 0em 0em",
            backgroundColor: "#ffeee4",
          }}
          vertical
        >
          {!isMobile &&
            <Grid container stackable verticalAlign="middle">
              <Grid.Row style={{ height: "500px" }} columns={1}>
                <Grid.Column width={8}>
                  <Header style={{ fontSize: '28px', color: '#F37021', marginTop:"50px" }}>비즈니스 </Header>
                  <Header style={{ fontSize: '48px' }}>
                    기업의 인력 보완
                  </Header>
                  <Button style={{marginTop:'40px'}} color="orange" className="huge ui button" href="/sales/">구매 상담</Button>
                </Grid.Column>
                <Grid.Column style={{ marginLeft: "200px", marginTop:"-300px"}}>
                  <Image src="/enterprise1.png" style={{width:'1000px', height:'536px', marginTop:'50px'}}/>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          }
           {isMobile &&
            <Grid container stackable verticalAlign="middle">
            <Grid.Row columns={2}>
              <Grid.Column style={{textAlign:"center"}}>
                <Header as="h3" style={{marginTop:"15px", textAlign:"center"}}>비즈니스 </Header>
                <Header style={{ fontSize: '28px' }}>
                기업의 인력 보완
                </Header>
                <Image style={{width:"311px", margin:"auto"}} src="/enterprise_mobile.png" />
                <Button style={{marginTop:'40px'}} color="orange" className="huge ui button" href="/sales/">구매 상담</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          }
        </Segment>

        <div className='solution-divider'></div>

        

        <Header as="h1" textAlign="center" style={{ fontSize: "3em" }}>
          비즈니스
        </Header>

        <Divider hidden />

        <Grid container stackable verticalAlign="middle">
          <Grid.Row columns={2}>
            {isMobile &&<Grid.Column>
              <Image style={{width:isMobile ? "311px" : "auto" , margin:"auto"}} src="/enterprise2.png" />
            </Grid.Column>}



            <Grid.Column>
              <Header as="h3">비즈니스</Header>
              <Header as="h1">Muse J X Ken Robotech</Header>
              <p style={{fontSize:"24px"}}>
                아카와 켄 로보테크는 음성 통신 기능이 탑재된 로봇을 공동개발하여 건설현장에서의 생산성을 향상시켰습니다.{" "}
              </p>
              <p style={{fontSize:"24px"}}>
                켄 로보테크에 의해 개발 및 판매되어 노동자들의 부담을 줄임.
              </p>

              {
                !isMobile &&
                <a href="#" style={{ color: "#F2711C" , fontSize:"24px" }}>
                더 알아보기 <Icon name="arrow right" />
              </a>}

              {isMobile &&   <a  className='mobileLinkMainWatchVideo' href="#" style={{ color: "#F2711C" }}>더 알아보기 <Icon name="arrow right" /></a>}

              

            </Grid.Column>
            {!isMobile &&
            <Grid.Column>
              <Image src="/enterprise2.png" />
            </Grid.Column>
            }
          </Grid.Row>
        </Grid>

        <Divider hidden />
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />

        <Grid container stackable verticalAlign="middle">
          <Grid.Row columns={2}>
            {!isMobile &&
            <Grid.Column>
              <Image src="/enterprise3.png" />
            </Grid.Column>
            }
            {
              isMobile &&
              <Grid.Column>
                <Image style={{width:isMobile ? "311px" : "auto" , margin:"auto"}} src="/enterprise3.png" />
              </Grid.Column>
            }

            <Grid.Column>
              <Header as="h3" style={{marginTop:"40px"}}>비즈니스</Header>
              <Header as="h1">Muse J X VAIO</Header>
              <p style={{fontSize:"24px"}}>
              "VAIO의 '말하는 코우펜짱'에는 Muse의 일본어 NLP 엔진이 내장되어 있습니다.
              이 로봇은 일본에서 인기 많은 애니메이션 캐릭터를 바탕으로 제작되었으며, 독립형 버전과 클라우드 베이스 버전이 있습니다.
              솔루션에는 빌트인 발화 인식과 최첨단 합성 음성 기능이 있습니다."
              </p>
              

              {!isMobile &&  <a href="https://musioenglish.kr/" style={{ color: "#F2711C" ,fontSize:"24px"  }}>
                웹사이트로 이동 <Icon name="arrow right" />
              </a>}
              {isMobile &&   <a  className='mobileLinkMainWatchVideo' href="/ai/chat/" style={{ color: "#F2711C" }}>웹사이트로 이동 <Icon name="arrow right" /></a>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />
        <Divider hidden />

        <NextLevel />
      </>
    );
}
